/**
 * @generated SignedSource<<9af47e43957efa34895a7b6ff9f3b55d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBreadcrumbs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountSwitch_viewer">;
  readonly " $fragmentType": "AppBreadcrumbs_viewer";
};
export type AppBreadcrumbs_viewer$key = {
  readonly " $data"?: AppBreadcrumbs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppBreadcrumbs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountSwitch_viewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8a83ae4ee5b7b368294f254f284e02e9";

export default node;
